import React, { memo } from 'react';
import styles from './InvalidTag.module.less';

export default memo(() => {
  return (
    <div className={styles.invalid_tag}>
      <div>订阅服务已到期，以下壁纸无法进行轮播</div>
    </div>
  );
});
